import { Injectable, OnInit } from '@angular/core';
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    NavigationEnd,
    Router
} from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService implements OnInit {
    private history: string[] = [];
    private _activatedRouteSnapshotSubject: BehaviorSubject<ActivatedRouteSnapshot> =
        new BehaviorSubject<ActivatedRouteSnapshot>(null);
    public activatedRouteSnapshot$: Observable<ActivatedRouteSnapshot> =
        this._activatedRouteSnapshotSubject.asObservable();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    private set ActivatedRouteSnapshot(
        activatedRouteSnapshot: ActivatedRouteSnapshot
    ) {
        this._activatedRouteSnapshotSubject.next(activatedRouteSnapshot);
    }

    ngOnInit(): void {
        this.start();
    }

    public back(): void {
        if (this.history.length > 1) {
            this.history.pop();
            this.router.navigateByUrl(this.currentUrl);
        } else {
            this.router.navigateByUrl('/');
        }
    }

    private start() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this.currentUrl != event.urlAfterRedirects) {
                    this.history.push(event.urlAfterRedirects);
                }
                this.ActivatedRouteSnapshot = this.activatedRoute.snapshot;
            }
        });
    }

    get previousUrl(): string | null {
        return this.history[this.history.length - 2];
    }

    get currentUrl(): string | null {
        return this.history[this.history.length - 1];
    }
}
